<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 payment-methods" id="selling-goals">
  <po-widget>
    <span class="po-font-text-bold">Vendas x Metas por empresa</span>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div class="icon-loading" *ngIf="!loading && errorApi">
      <span class="po-icon po-icon-exclamation"></span>
    </div>
    <div class="po-md-12 po-text-center" *ngIf="!loading && errorApi">
      <span>
        Não foi possível carregar a informação de Vendas x Metas por empresa
      </span>
    </div>
    <div *ngIf="!loading && !errorApi">
      <fusioncharts width="100%" height="270" type="angulargauge" [dataSource]="dataSource">
      </fusioncharts>
    </div>
  </po-widget>
</div>